















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import WebRead from "../../../pt/package/SzgcProcessGetor/read/index.vue";
import MobileRead from "../../../mobile/package/SzgcMobileGetor/read/index.vue";

@Component({
  name: "SzgcReadGetor",
  components: {
    WebRead,
    MobileRead
  }
})
export default class SzgcReadGetor extends Vue {
  @Prop({
    type: String,
    default: "web"
  })
  private client!: string;

  @Prop({
    type: String,
    default: ""
  })
  private businessId!: any;

  private pageData: any = null;

  @Watch("businessId", { immediate: true })
  private getData(newVal: any) {
    if (newVal) {
      this.pageData = {
        businessId: newVal
      };
    }
  }

  async getBack() {
    if (this.client === "web") {
      return await (this.$refs.webReadMain as any).getBack();
    } else {
      return await (this.$refs.mobileReadMain as any).getBack();
    }
  }
}
